import React from "react";

const DashBoardIcon = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "23"}
      height={height ? height : "31"}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 17.2222H13.7778V0H0V17.2222ZM0 31H13.7778V20.6667H0V31ZM17.2222 31H31V13.7778H17.2222V31ZM17.2222 0V10.3333H31V0H17.2222Z"
        fill={color ? color : "gray"}
      />
    </svg>
  );
};

export default DashBoardIcon;
